import type MockAdapter from 'axios-mock-adapter'
import { PAGE_VIEW_ROLES, ROLE_NO, type RoleCode, WRITE_ROLES } from '../seed/platform.seed'
import { readTable } from '../store/localDb.store'
import { handle, idOf } from './c07.shared'
import { myRoles } from './masterData.shared'

/**
 * MST-00 Hub Master Data — `/api/v1/wms/master/hub`. Hitungan entri LIVE untuk tiap kartu master + hak peran aktif
 * (boleh melihat kartunya / boleh beraksi), diturunkan dari capability platform sehingga tidak ada dua sumber kebenaran.
 */

const HUB_PAGES = [
  'MST-01',
  'MST-02',
  'MST-03',
  'MST-04',
  'MST-05',
  'MST-06',
  'MST-07',
  'MST-08',
  'MST-09',
  'MST-10',
  'MST-11'
] as const

const STORAGE_TYPES = ['STORAGE', 'STORAGE_FG']
const PALLET_KIND = 'RM_QUARANTINE'

const countText: Record<(typeof HUB_PAGES)[number], () => string> = {
  'MST-01': () => `${readTable('mt_product').length} SKU`,
  'MST-02': () => `${readTable('mt_material').length} material`,
  'MST-03': () => `${new Set(readTable('mt_bill_of_material').map(line => idOf(line.sku_id))).size} SKU ber-BOM`,
  'MST-04': () => `${readTable('mt_companies').filter(row => row.type === 'supplier').length} supplier`,
  'MST-05': () => `${readTable('mt_companies').filter(row => row.type === 'customer').length} customer`,
  'MST-06': () =>
    `${
      readTable('mt_rack_bin').filter(bin => bin.is_active !== false).length +
      readTable('warehouse_zone').filter(zone => zone.zone_type === 'STORAGE_FG').length
    } lokasi`,
  'MST-07': () =>
    `${readTable('warehouse_zone').filter(zone => !STORAGE_TYPES.includes(String(zone.zone_type))).length} area`,
  'MST-08': () => `${readTable('sla_wms_setting').length} ambang`,
  'MST-09': () => `${readTable('mt_reject_type').filter(row => row.is_active !== false).length} alasan aktif`,
  'MST-10': () => `${readTable('pallet').filter(row => row.pallet_kind === PALLET_KIND).length} pallet`,
  'MST-11': () => `${readTable('mt_unit').filter(row => row.is_active !== false).length} satuan aktif`
}

export function hubSummary() {
  const roleNos = myRoles().map(code => ROLE_NO[code as RoleCode])
  const has = (list: number[] = []) => roleNos.some(no => list.includes(no))
  return {
    cards: HUB_PAGES.map(code => ({
      code,
      count_text: countText[code](),
      can_view: has(PAGE_VIEW_ROLES[code]),
      can_act: has(WRITE_ROLES[code])
    }))
  }
}

export function registerMasterHubHandlers(mock: MockAdapter) {
  mock.onGet('/api/v1/wms/master/hub').reply(() => handle(() => hubSummary()))
}
